import { fetchival } from '@exodus/fetch';
const createEmptyBalanceChanges = () => ({
    willSend: [],
    willApprove: [],
    willReceive: [],
    willPayFee: [],
});
export const createEmptySimulationResult = ({ asset, baseAssetName, }) => {
    // Not all web3 modules supply the `baseAssetName` property yet.
    const resolvedBaseAssetName = baseAssetName ?? asset?.baseAssetName;
    if (!resolvedBaseAssetName) {
        throw new Error("Either 'asset' or 'baseAssetName' should be supplied.");
    }
    return {
        baseAssetName: resolvedBaseAssetName,
        balanceChanges: createEmptyBalanceChanges(),
        transactions: [],
        displayDetails: { warnings: [] },
        advancedDetails: [],
        warnings: [],
        metadata: {
            simulatedLocally: true,
        },
    };
};
export async function makeSimulationAPICall(args) {
    const additionalParams = 'network' in args && 'chain' in args
        ? { network: args.network, chain: args.chain }
        : {};
    try {
        const response = await fetchival(args.url, {
            method: 'POST',
            headers: {
                ...args.headers,
                'Content-Type': 'application/json',
            },
        }).post({
            ...additionalParams,
            serviceProvider: 'blowfish',
            ...args.payload,
        });
        return response;
    }
    catch (error) {
        // ToDo: accept a logger dep and log the error
        return null;
    }
}
export const createScanDomains = ({ url, headers }) => (domains) => makeSimulationAPICall({
    url,
    headers,
    payload: { domains },
});
